import { buildSimpleExportSheet, tableHeaderStyle } from './simple-export'

const providentFundHeader = [
  '#',
  'Code',
  'Name',
  'Fund Entry Date',
  'Type of Fund',
  'Deducted %',
  'Resignation Date',
  'Round',
  'Status'
]

export function buildProvidentFundReportSheet({ data = [] }) {
  return buildSimpleExportSheet({
    header: providentFundHeader,
    data,
    sheetName: 'Provident-Fund',
    headerStyle: tableHeaderStyle
  })
}
